import { render, staticRenderFns } from "./index.vue?vue&type=template&id=07fbb426&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=07fbb426&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fbb426",
  null
  
)

export default component.exports